export default {
  PAYMENT: "Payment",
  PAYMENTS: "Payments",
};
